<script>
import Register from "./Register/Index";
import Schedule from "./Schedule";
import Orders from "./Orders";
import Ratings from "./Ratings/Index";
import Wallet from "./Wallet";
import Transfers from "@/components/Transfers/List";
import Districts from "./Districts/Index";
import Biography from "./Biography";
import Documents from "./Documents";
import BackgroundCheck from "./Documents/BackgroundCheck";
import Coupons from "./Coupons/Index";

export default {
  components: {
    Register,
    Schedule,
    Orders,
    Ratings,
    Wallet,
    Districts,
    Transfers,
    Biography,
    Documents,
    BackgroundCheck,
    Coupons
  },

  data() {
    return {
      tab: "schedule"
    };
  },

  props: {
    professional: {
      type: Object,
      required: true
    }
  },

  methods: {
    isActive(tab) {
      return this.tab === tab;
    },

    setInitialTab() {
      const postRegisterAccountStatuses = ["active", "inactive", "blocked"];

      if (
        !postRegisterAccountStatuses.includes(this.professional.account.status)
      ) {
        this.tab = "register";
      }
    }
  },

  mounted() {
    this.setInitialTab();
  }
};
</script>

<template>
  <div class="tab">
    <ul class="tab-buttons">
      <li @click="tab = 'register'" :class="{ active: isActive('register') }">
        Cadastro
      </li>
      <li @click="tab = 'schedule'" :class="{ active: isActive('schedule') }">
        Agenda
      </li>
      <li @click="tab = 'orders'" :class="{ active: isActive('orders') }">
        Pedidos
      </li>
      <li @click="tab = 'ratings'" :class="{ active: isActive('ratings') }">
        Avaliações
      </li>
      <li @click="tab = 'wallet'" :class="{ active: isActive('wallet') }">
        Carteira
      </li>
      <li @click="tab = 'districts'" :class="{ active: isActive('districts') }">
        Bairros
      </li>
      <li @click="tab = 'transfers'" :class="{ active: isActive('transfers') }">
        Transferências
      </li>
      <li @click="tab = 'biography'" :class="{ active: isActive('biography') }">
        Biografia
      </li>
      <li @click="tab = 'documents'" :class="{ active: isActive('documents') }">
        Documentos
      </li>
      <li
        @click="tab = 'background-check'"
        :class="{ active: isActive('background-check') }"
      >
        Antecedentes
      </li>
      <li @click="tab = 'coupons'" :class="{ active: isActive('coupons') }">
        Cupons
      </li>
    </ul>

    <div class="tab-content">
      <transition name="fade" mode="out-in">
        <component
          :is="tab"
          :professional="professional"
          @refresh="$emit('refresh')"
        ></component>
      </transition>
    </div>
  </div>
</template>

<style scoped>
.tab {
  width: 100%;
  height: auto;
}

.tab ul {
  display: flex;
  flex-direction: row;
  padding: 0;
  margin-bottom: 0;
}

.tab ul li {
  color: #333;
  padding: 10px 20px;
  background: #f3f3f3;
  border: 1px solid #e7e7e7;
  border-radius: 4px 4px 0 0;
  list-style: none;
  font-size: 14px;
  font-weight: 600;
  border-bottom: 0;
  cursor: pointer;
  transition: all 0.25s ease;
}

.tab ul li:hover {
  background: #e8e8e8;
}

.tab ul li.active {
  position: relative;
  top: 1px;
  background: #fff;
}

.tab .tab-content {
  border: 1px solid #e7e7e7;
  border-radius: 0 4px 4px 4px;
  padding: 20px 30px;
}

@media (max-width: 992px) {
  .tab ul li {
    padding: 10px 15px;
    font-size: 13px;
  }
}

@media (max-width: 768px) {
  .tab ul {
    display: block;
    margin-bottom: 20px;
  }

  .tab-content {
    border-radius: 4px !important;
  }

  .tab ul li {
    padding: 10px 15px;
    font-size: 13px;
    border-radius: 0;
  }

  .tab ul li:first-child {
    border-radius: 4px 4px 0 0;
  }

  .tab ul li:last-child {
    border-radius: 0 0 4px 4px;
    border-bottom: 1px solid #e7e7e7;
  }

  .tab .tab-content {
    padding: 5px;
  }

  .tab ul li.active {
    top: 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Professionals/Edit/Tabs/Index.vue